"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const gatsby_1 = require("gatsby");
const layout_1 = require("../components/layout");
const React = require("react");
const OtherTemplate = ({ data, }) => {
    const { markdownRemark } = data;
    if (!markdownRemark || !markdownRemark.frontmatter)
        return React.createElement("div", null);
    const { frontmatter, html } = markdownRemark;
    return (React.createElement(layout_1.default, null,
        React.createElement("div", { className: "project-container" },
            React.createElement("div", { className: "project" },
                React.createElement("h1", null, frontmatter.title),
                React.createElement("div", null, (frontmatter.tags || []).map(tag => React.createElement("span", { key: tag || '' }, tag))),
                React.createElement("div", { className: "project-content", dangerouslySetInnerHTML: { __html: html || '' } })))));
};
exports.pageQuery = gatsby_1.graphql `
  query otherPage ($path: String!) {
    markdownRemark(fields: { slug: { eq: $path } }) {
      html
      frontmatter {
        title
        tags
      }
    }
  }
`;
exports.default = OtherTemplate;
